import { Spinner } from "@components";
import type { NavItemType } from "@/components/application/app-navigation/config";

const INFRACTIONS_MANAGEMENT_LABEL = "Gestão de Infrações";

type MapInfractionsNavItemsParams = {
	openHabilitarMeInNewTab: () => void;
	isSigningInHabilitarMe: boolean;
};

export function mapInfractionsNavItems(
	items: NavItemType[],
	{
		openHabilitarMeInNewTab,
		isSigningInHabilitarMe,
	}: MapInfractionsNavItemsParams
): NavItemType[] {
	return items.map((item) => {
		if (item.label !== "Infrações" || !item.items?.length) {
			return item;
		}

		return {
			...item,
			items: item.items.map((subItem) => {
				if (subItem.label !== INFRACTIONS_MANAGEMENT_LABEL) {
					return subItem;
				}

				return {
					...subItem,
					badge: isSigningInHabilitarMe ? (
						<Spinner className="size-4" disabled />
					) : null,
					onClick: () => {
						openHabilitarMeInNewTab();
					},
				};
			}),
		};
	});
}
